import { render, staticRenderFns } from "./OrdenCompraDetalle.vue?vue&type=template&id=787c8252&"
import script from "./OrdenCompraDetalle.vue?vue&type=script&lang=js&"
export * from "./OrdenCompraDetalle.vue?vue&type=script&lang=js&"
import style0 from "./OrdenCompraDetalle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports